import React from 'react';
import { AlertCircleIcon } from 'lucide-react';
type EstimateFieldProps = {
  id: string;
  label: string;
  required?: boolean;
  optional?: boolean;
  hint?: string;
  error?: string;
  className?: string;
  asGroup?: boolean;
  children: React.ReactNode;
};
export const fieldClasses = (hasError: boolean) => `w-full rounded-2xl border bg-white px-4 text-[15px] text-forest placeholder:text-forest/40 transition focus:outline-none focus:ring-4 ${hasError ? 'border-red-600/70 focus:border-red-600 focus:ring-red-600/10' : 'border-forest/15 hover:border-forest/30 focus:border-olive focus:ring-olive/15'}`;
export function EstimateField({
  id,
  label,
  required,
  optional,
  hint,
  error,
  className = '',
  asGroup,
  children
}: EstimateFieldProps) {
  const labelClass = 'flex flex-wrap items-center gap-1 text-sm font-semibold text-forest';
  const content = <>
      {label}
      {required && <span className="text-[#9B2335]" aria-hidden="true" data-id="element-42" data-mp="2a80zq5jfs509">
          *
        </span>}
      {optional && <span className="font-normal text-forest/50" data-id="element-43" data-mp="2tedo5qv4u6az">(optional)</span>}
    </>;
  return <div className={className} data-id="element-44" data-mp="2ycox7zdlscs5">
      {asGroup ? <span id={`${id}-label`} className={labelClass} data-id="element-45" data-mp="334yn5fepxcuf">
          {content}
        </span> : <label htmlFor={id} className={labelClass} data-id="element-46" data-mp="3761yboltmkpb">
          {content}
        </label>}
      {hint && <p className="mt-1 text-[13px] leading-relaxed text-forest/55" data-id="element-47" data-mp="2agkkungljud2">{hint}</p>}
      <div className="mt-2" data-id="element-48" data-mp="2ff4b30283sb8">{children}</div>
      {error && <p id={`${id}-error`} className="mt-2 flex items-center gap-1.5 text-[13px] font-medium text-red-700" data-id="element-49" data-mp="2ffe1gor6k1hg">
          <AlertCircleIcon className="h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-50" data-mp="2jitvrefs1pqz" />
          {error}
        </p>}
    </div>;
}